// Service-based landing pages (Google Ads compliant — no team/human framing)
import { girls } from "./girls";

export const landings = [
  {
    slug: "sahne-servisi",
    type: "service",
    matchTags: ["Sahne / Show", "Stage / Show"],
    hero: "https://images.unsplash.com/photo-1501281668745-f7f57925c3b4?w=1920&q=85",
    tr: {
      breadcrumb: "Sahne & Show",
      h1: "Girne Sahne, Kabare ve Gece Kulübü Show Servisi",
      subtitle: "Cabaret, aerial silk, DJ set, canlı vokal ve lazer sahne organizasyonu",
      intro:
        "Girne'nin lisanslı sahne kulüplerinde kabare stili şov geceleri, aerial silk performansları, canlı DJ setleri ve lazer sahne organizasyonu.",
      seoParagraphs: [
        "Girne'nin gece sahnesi Akdeniz'in en canlı ve profesyonel şov ekosistemidir. Cabaret & Stage Show, Aerial Silk & Pole Performance, Live DJ Night, VIP Bottle & Champagne, Laser & Stage Experience ve Live Vocals & Piano paketleriyle her misafiri farklı bir atmosferle karşılıyoruz.",
        "Kabare geceleri koreografi, canlı sahne performansı ve konser hissi veren ışık şovlarıyla; DJ geceleri ise house, techno, latin ve Türkçe pop setleriyle şekilleniyor. VIP masa rezervasyonu ve şampanya töreni her pakete dahil edilebiliyor.",
        "Bekarlığa veda partileri, doğum günü kutlamaları ve kurumsal etkinlikler için özel show paketleri hazırlıyoruz. WhatsApp üzerinden dakikalar içinde özel teklif alın.",
      ],
    },
    en: {
      breadcrumb: "Stage & Show",
      h1: "Kyrenia Stage, Cabaret & Nightclub Show Service",
      subtitle: "Cabaret, aerial silk, DJ sets, live vocals and laser stage organisation",
      intro:
        "Cabaret-style show nights, aerial silk performances, live DJ sets and laser stage organisation at Kyrenia's licensed stage clubs.",
      seoParagraphs: [
        "Kyrenia's night scene is one of the Mediterranean's most vibrant and professional show ecosystems. Cabaret & Stage Show, Aerial Silk & Pole Performance, Live DJ Night, VIP Bottle & Champagne, Laser & Stage Experience and Live Vocals & Piano — each package delivers a distinct atmosphere.",
        "Cabaret nights are shaped with choreography, live stage performance and concert-like lighting; DJ nights bring house, techno, latin and Turkish pop sets. VIP table reservation and champagne rituals can be added to every package.",
        "Bespoke show packages for bachelor parties, birthdays and corporate events. Get a bespoke quote on WhatsApp within minutes.",
      ],
    },
  },
  {
    slug: "otel-servisi",
    type: "service",
    matchTags: ["5★ Otel", "Villa", "Resort", "5★ Hotel"],
    hero: "https://images.unsplash.com/photo-1566073771259-6a8506099945?w=1920&q=80",
    tr: {
      breadcrumb: "Otel Servisi",
      h1: "Girne 5 Yıldızlı Otel Rezervasyon Servisi",
      subtitle: "Cratos, Merit, Acapulco, Concorde, Lord's Palace",
      intro:
        "Girne'nin premium otellerinde rezervasyon önceliği, oda upgrade koordinasyonu ve VIP karşılama.",
      seoParagraphs: [
        "Cratos Premium, Merit Crystal Cove, Acapulco Resort, Concorde Luxury ve Lord's Palace gibi 5 yıldızlı Girne otelleriyle güçlü işbirliğimiz sayesinde misafirlerimize rezervasyon önceliği sunuyoruz.",
        "Deniz manzaralı süitler, kral daireleri, özel plaj villaları ve tema resort odaları — bütçenize ve tarzınıza uygun konaklama seçenekleri.",
        "Bal ayı, doğum günü ve özel kutlama misafirlerimize ekstra ikramlar organize edilir. WhatsApp üzerinden özel teklif alın.",
      ],
    },
    en: {
      breadcrumb: "Hotel Service",
      h1: "Kyrenia 5-Star Hotel Booking Service",
      subtitle: "Cratos, Merit, Acapulco, Concorde, Lord's Palace",
      intro:
        "Reservation priority, room-upgrade coordination and VIP welcome at Kyrenia's premium hotels.",
      seoParagraphs: [
        "Thanks to our strong partnerships with 5-star Kyrenia hotels such as Cratos Premium, Merit Crystal Cove, Acapulco Resort, Concorde Luxury and Lord's Palace, we secure reservation priority for our guests.",
        "Sea-view suites, presidential suites, private beach villas and themed resort rooms — accommodation options for every budget and style.",
        "Extra touches are arranged for honeymoon, birthday and celebration guests. Request a bespoke quote on WhatsApp.",
      ],
    },
  },
  {
    slug: "casino-servisi",
    type: "service",
    matchTags: ["Casino"],
    hero: "https://images.unsplash.com/photo-1596838132731-3301c3fd4317?w=1920&q=80",
    tr: {
      breadcrumb: "Casino Servisi",
      h1: "Girne Casino Rehberliği ve VIP Salon Koordinasyonu",
      subtitle: "Cratos, Merit, Acapulco — VIP salon erişimi ve etiket rehberi",
      intro:
        "Kuzey Kıbrıs'ın en prestijli casinolarında yüksek limitli salon erişimi, etiket rehberliği ve masa rezervasyonu.",
      seoParagraphs: [
        "Cratos Premium, Merit Crystal Cove ve Acapulco Resort casinolarında ilk kez oynayanlara etiket rehberliği, oyun kuralları anlatımı ve çok dilli tercüme desteği veriyoruz.",
        "Blackjack, rulet, poker, baccarat ve slot bölümlerinde masa rezervasyonu. Yüksek limitli oyunculara özel VIP salon erişimi ve şef koordinasyonu.",
        "Uluslararası poker turnuvaları için kayıt ve rebuy planlaması yapıyoruz. WhatsApp üzerinden koordinasyon.",
      ],
    },
    en: {
      breadcrumb: "Casino Service",
      h1: "Kyrenia Casino Guide & VIP Salon Coordination",
      subtitle: "Cratos, Merit, Acapulco — VIP salon access and etiquette guide",
      intro:
        "High-limit salon access, etiquette guidance and table reservations at Northern Cyprus's most prestigious casinos.",
      seoParagraphs: [
        "We provide etiquette guidance, rules explanation and multilingual translation support for first-time players at Cratos Premium, Merit Crystal Cove and Acapulco Resort casinos.",
        "Table reservations across blackjack, roulette, poker, baccarat and slots. Private VIP salon access and chef coordination for high-limit players.",
        "For international poker tournaments we handle registration and rebuy planning. Coordinate on WhatsApp.",
      ],
    },
  },
  {
    slug: "yat-servisi",
    type: "service",
    matchTags: ["Yat / Deniz", "Yacht / Sea"],
    hero: "https://images.unsplash.com/photo-1567899378494-47b22a2ae96a?w=1920&q=80",
    tr: {
      breadcrumb: "Yat Servisi",
      h1: "Girne Yat Kiralama ve Karpaz Tur Organizasyonu",
      subtitle: "Gün batımı, yarım gün ve tam gün yat paketleri",
      intro:
        "Girne Yat Limanı'ndan kalkışlı lüks yat kiralama, kaptan koordinasyonu, catering ve şampanya servisi.",
      seoParagraphs: [
        "Girne'nin denizi Akdeniz'in en güzel yat rotalarından birini sunar. Karpaz kıyılarında mavi bayrak plajları, sessiz koylar ve gün batımı manzaraları.",
        "Yat kiralama paketimiz 2-12 kişi kapasitesinde, catering ve kaptan koordinasyonu dahil. Bekarlığa veda ve doğum günü kutlamaları için popüler seçim.",
        "3 saatlik gün batımı turu, 6 saatlik yarım gün ve tam gün paketleri mevcut. WhatsApp üzerinden özel teklif.",
      ],
    },
    en: {
      breadcrumb: "Yacht Service",
      h1: "Kyrenia Yacht Charter & Karpaz Tour Organisation",
      subtitle: "Sunset, half-day and full-day yacht packages",
      intro:
        "Luxury yacht charter from Kyrenia Marina — captain coordination, catering and champagne service.",
      seoParagraphs: [
        "Kyrenia's sea offers one of the Mediterranean's most beautiful yacht routes. Blue-flag beaches, silent coves and sunset vistas along the Karpaz coast.",
        "Our yacht package supports 2–12 guests with catering and captain coordination included. A popular pick for bachelor and birthday celebrations.",
        "3-hour sunset, 6-hour half-day and full-day packages available. Request a bespoke quote on WhatsApp.",
      ],
    },
  },
  {
    slug: "dans-vip-servisi",
    type: "service",
    matchTags: ["Dans / Gece", "Dance / Nightlife", "Bar / Terrace"],
    hero: "https://images.unsplash.com/photo-1514525253161-7a46d19cd819?w=1920&q=80",
    tr: {
      breadcrumb: "VIP Dans & Gece",
      h1: "Girne VIP Dans, Gece Kulübü ve Cocktail Bar Servisi",
      subtitle: "Beach club, VIP masa, rooftop bar ve dans pisti koordinasyonu",
      intro:
        "Girne'nin en populer gece kulüplerinde VIP masa, öncelikli giriş ve bottle service koordinasyonu.",
      seoParagraphs: [
        "Girne'nin gece hayatı Akdeniz'in en canlı sahnelerinden biridir. Beach club'lar, rooftop bar'lar ve gece kulüpleri her zevke hitap eder.",
        "VIP masa rezervasyonu, öncelikli giriş, DJ set koordinasyonu ve bottle service konularında ekibimiz sizi destekler. Bekarlığa veda ve doğum günü kutlamaları için özel paketlerimiz vardır.",
        "24 saat önceden yapılan rezervasyonlarda esnek iptal. WhatsApp üzerinden özel teklif alın.",
      ],
    },
    en: {
      breadcrumb: "VIP Dance & Nightlife",
      h1: "Kyrenia VIP Nightlife, Cocktail Bar & Dance Service",
      subtitle: "Beach club, VIP table, rooftop bar and dance-floor coordination",
      intro:
        "VIP tables, priority entry and bottle-service coordination at Kyrenia's most popular nightclubs.",
      seoParagraphs: [
        "Kyrenia's nightlife is one of the Mediterranean's most vibrant scenes. Beach clubs, rooftop bars and nightclubs cover every taste.",
        "Our team supports you with VIP table reservations, priority entry, DJ-set coordination and bottle service. Bespoke packages available for bachelor and birthday celebrations.",
        "Flexible cancellation with 24-hour advance notice. Request a bespoke quote on WhatsApp.",
      ],
    },
  },
  // ═══ NEW SEO LANDINGS — nightlife, entertainment guide, residence ═══
  {
    slug: "kibris-gece-hayati",
    type: "guide",
    matchTags: ["Sahne / Show", "Stage / Show", "Dans / Gece", "Dance / Nightlife"],
    hero: "https://images.unsplash.com/photo-1516450360452-9312f5e86fc7?w=1920&q=85",
    tr: {
      breadcrumb: "Kıbrıs Gece Hayatı",
      h1: "Kıbrıs & Girne Gece Hayatı Rehberi — Night Club, Cabaret, Sahne Şovu",
      subtitle: "Akdeniz'in en canlı gece sahnesi: night club, cabaret, direk dansı ambiyansı ve VIP masa koordinasyonu",
      intro:
        "Kıbrıs gece hayatı, Girne başta olmak üzere Akdeniz'in en zengin ve profesyonel eğlence sahnelerinden biridir. Cabaret, aerial silk, sahne şovu, direk dansı ambiyansı, lazer geceleri ve canlı DJ setleri.",
      seoParagraphs: [
        "Girne night club sahnesi hem yerel hem de uluslararası ziyaretçiler için özel olarak konumlanmış bir eğlence hattıdır. Cratos, Merit ve Acapulco gibi büyük otel-kompleksleri kendi lisanslı sahnelerine sahip; şehir merkezinde ise butik nightclub'lar, cabaret salonları ve rooftop bar'lar bulunuyor.",
        "Kıbrıs Night Club'un rolü, sizi doğrudan doğru mekana yönlendirmek, VIP masa rezervasyonunu koordine etmek ve şampanya bottle service (Dom Pérignon, Cristal, Moët Rose) düzenlemektir. Cabaret & aerial silk gösterileri, direk dansı ambiyansı sunan lazer sahne şovları ve klasik canlı DJ geceleri için özel paketlerimiz mevcuttur.",
        "Bekarlığa veda geceleri, doğum günleri, kurumsal etkinlikler ve VIP misafir grupları için kişiye özel gece hayatı paketleri hazırlıyoruz. Havalimanından direkt night club transferi + otel/rezidans check-in + sahne şovu + geri dönüş: tek WhatsApp mesajı ile tüm süreç ekibimiz tarafından koordine ediliyor.",
        "Girne dışında Lefkoşa ve Gazimağusa gece hayatı için de rezervasyon ve transfer sağlıyoruz. 7 dilde (TR, EN, RU, DE, FR, IT, AR) hizmet.",
      ],
    },
    en: {
      breadcrumb: "Cyprus Nightlife",
      h1: "Cyprus & Kyrenia Nightlife Guide — Nightclub, Cabaret, Stage Show",
      subtitle: "The Mediterranean's most vibrant night scene: nightclub, cabaret, pole-dance ambiance and VIP table coordination",
      intro:
        "Cyprus nightlife, led by Kyrenia, is one of the Mediterranean's richest and most professional entertainment scenes. Cabaret, aerial silk, stage show, pole-dance ambiance, laser nights and live DJ sets.",
      seoParagraphs: [
        "The Kyrenia night club scene is positioned for both local and international visitors. Cratos, Merit and Acapulco hotel complexes host their own licensed stage venues; downtown offers boutique nightclubs, cabaret rooms and rooftop bars.",
        "Kıbrıs Night Club's role is to route you to the right venue, coordinate the VIP table reservation and arrange the champagne bottle service (Dom Pérignon, Cristal, Moët Rose). Bespoke packages for cabaret & aerial silk shows, pole-dance ambiance laser nights and classic live DJ evenings.",
        "Bespoke nightlife packages for bachelor parties, birthdays, corporate events and VIP guest groups. Airport-direct-nightclub transfer + hotel/residence check-in + stage show + return: coordinated end-to-end via a single WhatsApp message.",
        "Beyond Kyrenia, we support Nicosia and Famagusta nightlife with reservations and transfers. 7-language service (TR, EN, RU, DE, FR, IT, AR).",
      ],
    },
  },
  {
    slug: "kibris-eglence-rehberi",
    type: "guide",
    matchTags: ["Sahne / Show", "Stage / Show", "Dans / Gece", "Dance / Nightlife", "Casino", "Yat / Deniz", "Yacht / Sea", "Bar / Terrace"],
    hero: "https://images.unsplash.com/photo-1518895312237-a9e23508077d?w=1920&q=85",
    tr: {
      breadcrumb: "Kıbrıs Eğlence Rehberi",
      h1: "Kıbrıs Eğlence Rehberi — Aktivite, Casino, Yat, Night Club & Tur",
      subtitle: "Girne, Lefkoşa ve Karpaz'da yapılabilecek her şey — tek rehberde",
      intro:
        "Kıbrıs eğlence sahnesi bir gün-gece döngüsüdür: gündüz beach club, yat & Karpaz turu; akşam 5 yıldızlı otel süiti, casino ve fine-dining; gece night club, cabaret sahnesi ve rooftop bar.",
      seoParagraphs: [
        "Girne eğlence rehberimiz; günün her saatine göre 25+ deneyim ve aktiviteyi kapsar. Gündüz: Acapulco Beach Club havuz partileri, Karpaz Ada turu, glass-bottom tekne, dalış, ATV safari ve yat kiralama. Akşam: 5 yıldızlı otel süit check-in, Michelin-yıldızlı seviyede fine dining, cocktail bar ve rooftop terrace.",
        "Kıbrıs casino sahnesi Akdeniz'in en gelişmiş hattıdır — Cratos, Merit Crystal Cove, Acapulco, Grand Pasha, Lord's Palace, Kaya Artemis ve Elexus dahil 20+ 5 yıldızlı casino. Blackjack, rulet, baccarat, poker turnuvaları ve slot salonları. VIP salon erişimi ve masa rezervasyonu ekibimizle.",
        "Gece hayatı bloğunda: night club VIP masa, cabaret & sahne şovları, aerial silk & direk dansı ambiyansı, canlı DJ setleri ve şampanya bottle service. Her etkinlik için havalimanı-otel-mekan-rezidans transferi lüks araç filosu ile.",
        "Kıbrıs Night Club, 2015'ten beri Girne'de faaliyet gösteren, 7 dilli ekibiyle bu 25+ deneyimi tek WhatsApp mesajıyla planlayabilen VIP konsiyerj servisidir. Talep edin, ekibimiz dakikalar içinde kişiye özel teklifle döner.",
      ],
    },
    en: {
      breadcrumb: "Cyprus Entertainment Guide",
      h1: "Cyprus Entertainment Guide — Activity, Casino, Yacht, Nightclub & Tour",
      subtitle: "Everything to do in Kyrenia, Nicosia and Karpaz — in one guide",
      intro:
        "The Cyprus entertainment scene is a day-to-night cycle: daytime beach club, yacht & Karpaz tour; evening 5-star hotel suite, casino and fine dining; night nightclub, cabaret stage and rooftop bar.",
      seoParagraphs: [
        "Our Kyrenia entertainment guide covers 25+ experiences and activities for every hour of the day. Daytime: Acapulco Beach Club pool parties, Karpaz Peninsula tour, glass-bottom boat, diving, ATV safari and yacht charter. Evening: 5-star suite check-in, Michelin-level fine dining, cocktail bar and rooftop terrace.",
        "The Cyprus casino scene is the Mediterranean's most developed corridor — 20+ 5-star casinos including Cratos, Merit Crystal Cove, Acapulco, Grand Pasha, Lord's Palace, Kaya Artemis and Elexus. Blackjack, roulette, baccarat, poker tournaments and slot rooms. VIP lounge access and table reservations with our team.",
        "For nightlife: nightclub VIP table, cabaret & stage shows, aerial silk & pole-dance ambiance, live DJ sets and champagne bottle service. Airport-hotel-venue-residence transfer with luxury car fleet for every event.",
        "Kıbrıs Night Club, operating in Kyrenia since 2015 with its 7-language team, is the VIP concierge that plans these 25+ experiences via a single WhatsApp message. Request now and we return with a bespoke quote within minutes.",
      ],
    },
  },
  {
    slug: "girne-rezidans-hizmeti",
    type: "service",
    matchTags: ["5★ Otel", "5-star Hotel", "Villa", "Resort"],
    hero: "https://images.unsplash.com/photo-1566073771259-6a8506099945?w=1920&q=85",
    tr: {
      breadcrumb: "Girne Rezidans",
      h1: "Girne Rezidans, Konsept Ev & VIP Kalış Hizmeti",
      subtitle: "Kısa & uzun dönem rezidans, deniz manzaralı villa ve konsept ev kiralama koordinasyonu",
      intro:
        "Girne'de otel dışında bir alternatif arayan VIP misafirlere yönelik özel rezidans, konsept ev ve villa kiralama koordinasyonu. Tam donanımlı, günlük temizlik ve concierge dahil.",
      seoParagraphs: [
        "Otel süiti bazen yetmez. Yat limanına 3 dakika yürüme mesafesindeki deniz manzaralı rezidanslardan, Karaoğlanoğlu ve Alsancak bölgesindeki 2-6 yatak odalı konsept evlere ve özel havuzlu villalara kadar tüm alternatiflerde Kıbrıs Night Club rezervasyon koordinasyonu sağlar.",
        "Ne dahil: Tam donanımlı mutfak, günlük ev temizliği, taze havlu ve nevresim değişimi, WiFi 500 Mbps, klima, akıllı TV ve Netflix, özel park yeri. VIP paketlerde: özel şef, günlük çiçek servisi, şampanya karşılaması ve yat/casino transfer talebi.",
        "Süre esnektir — minimum 3 gece, uzun süreli aylık kiralama seçenekleri de mevcut. Airbnb/Booking'de listelenmeyen özel havuz villaları için de erişimimiz vardır. Konsept ev, apart-otel ve rezidans arasındaki farkı size özel gösterip en uygun seçeneği öneririz.",
        "Sadece kalış değil, bir kalış deneyimi: rezidans check-in ile beraber restoran rezervasyonu, night club VIP masa, casino koordinasyonu ve Karpaz yat turu tek paket olarak planlanabilir. WhatsApp'tan iletişime geçin, ekibimiz dakikalar içinde kişiye özel bir teklifle döner.",
      ],
    },
    en: {
      breadcrumb: "Kyrenia Residence",
      h1: "Kyrenia Residence, Concept House & VIP Stay Service",
      subtitle: "Short & long-term residence, sea-view villa and concept-house rental coordination",
      intro:
        "Bespoke residence, concept house and villa rental coordination for VIP guests seeking an alternative to hotels in Kyrenia. Fully equipped, daily cleaning and concierge included.",
      seoParagraphs: [
        "A hotel suite isn't always enough. From sea-view residences three minutes walking from Kyrenia marina, to 2–6-bedroom concept houses in Karaoğlanoğlu and Alsancak, and private-pool villas — Kıbrıs Night Club coordinates reservations across every alternative.",
        "Included: fully equipped kitchen, daily housekeeping, fresh towels and linens, 500 Mbps WiFi, air conditioning, smart TV with Netflix, private parking. VIP packages add: private chef, daily flower service, champagne welcome and yacht/casino transfer on request.",
        "Duration is flexible — minimum 3 nights, monthly long-term rental also available. We also have access to private-pool villas not listed on Airbnb/Booking. We'll walk you through the differences between concept house, apart-hotel and residence, and recommend the fit.",
        "Not just a stay — a stay experience: with the residence check-in we can bundle restaurant reservation, nightclub VIP table, casino coordination and Karpaz yacht tour into a single package. Message us on WhatsApp and we return with a bespoke quote within minutes.",
      ],
    },
  },
];

// Helper — filter items for a landing by category (nationality field now holds category)
export const landingGirls = (landing) => {
  return girls.filter(
    (g) =>
      landing.matchTags.includes(g.nationality_tr) ||
      landing.matchTags.includes(g.nationality_en),
  );
};
